import * as angular from 'angular';
import FlowGroupsBridge from './FlowGroupsBridge';

angular
  .module('flowingly.runner.directives')
  .component('flowGroups', FlowGroupsBridge);
